import { ref } from 'vue'

const snackbar = ref({
  show: false,
  text: '',
  color: 'primary',
  timeout: 4000,
  location: 'top'
})

export function useSnackbar() {
  const showSnackbar = (text, color = 'primary', options = {}) => {
    snackbar.value = {
      show: true,
      text,
      color,
      timeout: options.timeout || 4000,
      location: options.location || 'top',
      ...options
    }
  }

  const hideSnackbar = () => {
    snackbar.value.show = false
  }

  const showSuccess = (text, options = {}) => showSnackbar(text, 'success', options)
  const showError = (text, options = {}) => showSnackbar(text, 'error', { timeout: 6000, ...options })
  const showWarning = (text, options = {}) => showSnackbar(text, 'warning', { timeout: 5000, ...options })
  const showInfo = (text, options = {}) => showSnackbar(text, 'info', options)

  return { snackbar, showSnackbar, hideSnackbar, showSuccess, showError, showWarning, showInfo }
}
